// Clock — live time display in Italian timezone (Europe/Rome).
// Renders HH:MM:SS in the navbar. Updates every second.

import { useEffect, useState } from "react";

function formatRomeTime(d = new Date()) {
  try {
    return new Intl.DateTimeFormat("it-IT", {
      timeZone: "Europe/Rome",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(d);
  } catch {
    // Fallback: local time
    return d.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  }
}

export default function Clock() {
  const [time, setTime] = useState(() => formatRomeTime());

  useEffect(() => {
    const id = setInterval(() => setTime(formatRomeTime()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="navbar-clock"
      title="Fuso orario Europe/Rome"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.35rem",
        padding: "0.2rem 0.55rem",
        background: "var(--bc-panel-elev, var(--bc-panel-elev, rgba(255,255,255,0.03)))",
        border: "1px solid var(--bc-border, rgba(255,255,255,0.07))",
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: "0.72rem",
        color: "rgba(255,255,255,0.78)",
        letterSpacing: "0.06em",
        lineHeight: 1,
        fontVariantNumeric: "tabular-nums",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 5,
          height: 5,
          borderRadius: "50%",
          background: "#22C55E",
          boxShadow: "0 0 6px rgba(34,197,94,0.8)",
          animation: "bc-clock-pulse 2s ease-in-out infinite",
        }}
      />
      <span>{time}</span>
      <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.6rem", letterSpacing: "0.1em" }}>IT</span>
      <style>{`
        @keyframes bc-clock-pulse {
          0%,100% { opacity: 1; }
          50%     { opacity: 0.35; }
        }
      `}</style>
    </div>
  );
}
